import { AllergenTableEntrySchema, type AllergenTableEntry } from '@restaurant/api-contracts';

export interface LegendEntry {
  shortKey: string;
  description: string;
  kind: AllergenTableEntry['kind'];
  inTable: boolean;
}

const keyOf = (shortKey: string) => shortKey.trim().toLowerCase();

export function missingLegend(
  legend: LegendEntry[],
  table: AllergenTableEntry[],
): AllergenTableEntry[] {
  const known = new Set(table.map((entry) => keyOf(entry.shortKey)));
  return legend.flatMap((entry) => {
    if (entry.inTable || known.has(keyOf(entry.shortKey))) return [];
    known.add(keyOf(entry.shortKey));
    const parsed = AllergenTableEntrySchema.safeParse({
      shortKey: entry.shortKey,
      description: entry.description,
      kind: entry.kind,
    });
    return parsed.success ? [parsed.data] : [];
  });
}

export const mergeLegend = (
  table: AllergenTableEntry[],
  additions: AllergenTableEntry[],
): AllergenTableEntry[] => [...table, ...additions];
